import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const therapistInfo = {
  name: "Keith Scherdt, LPC, LMHC",
  phone: "(808) 470-7650",
  email: "keith@mhcmaui.com",
  address: "2200 Main Street",
  city: "Wailuku",
  state: "HI",
  zip: "96793",
  location: "Wailuku, HI"
};

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Mindful Health Counseling</h3>
            <p className="text-sm mb-4">
              Professional parenting and family therapy services in Hawaii. 
              Helping families build stronger relationships and overcome challenges.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-teal-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <a href="/#about" className="text-sm hover:text-teal-400 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="/#services" className="text-sm hover:text-teal-400 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <Link to="/resources" className="text-sm hover:text-teal-400 transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-teal-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>Parenting Support</li>
              <li>Family Therapy</li>
              <li>Child & Adolescent Counseling</li>
              <li>Anxiety & Depression</li>
              <li>Trauma & PTSD</li>
              <li>Adoption Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-teal-400" />
                <span className="text-sm">
                  {therapistInfo.address}<br />
                  {therapistInfo.city}, {therapistInfo.state} {therapistInfo.zip}
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0 text-teal-400" />
                <a href={`tel:${therapistInfo.phone.replace(/[^0-9]/g, '')}`} className="text-sm hover:text-teal-400 transition-colors">
                  {therapistInfo.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-3 flex-shrink-0 text-teal-400" />
                <a href={`mailto:${therapistInfo.email}`} className="text-sm hover:text-teal-400 transition-colors">
                  {therapistInfo.email}
                </a>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-gray-700">
              <p className="text-xs">
                <strong>Telehealth Available</strong><br />
                Accepting New Clients
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Mindful Health Counseling. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
